import { gql } from "@apollo/client";

export const LOAD_NOTIFICATION_SETTINGS_QUERY = gql`
  query LoadNotificationSettings {
    loadNotificationSettings {
      id
      templateName
      description
      event {
        id
        displayName
        description
        availableVariables
      }
      templateVariables
      templateContent
      templateEmailSubject
      channel
      recipientType
    }
  }
`;

export const LOAD_NOTIFICATION_VARIABLES_QUERY = gql`
  query LoadNotificationVariables {
    loadNotificationVariables {
      id
      key
      displayName
      description
    }
  }
`;

export const UPDATE_NOTIFICATION_SETTING_MUTATION = gql`
  mutation UpdateNotificationSetting($input: UpdateNotificationSettingInput!) {
    updateNotificationSetting(input: $input) {
      result {
        ... on NotificationSetting {
          __typename
          id
          templateContent
          templateVariables
        }
        ... on UpdateNotificationSettingFailure {
          __typename
          reason
        }
      }
    }
  }
`;
